<template>
  <v-expansion-panels accordion :value="opened">
    <v-expansion-panel>
      <v-expansion-panel-header expand-icon="mdi-menu-down">
        Resumo da compra
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container class="py-0">
          <!-- <v-row v-if="showDiscountPercentage" class="background-orange">
            <v-col cols="8">DESCONTO GREEN FRIDAY</v-col>
            <v-col cols="4" align="end"
              >{{ getSelectedPaymentMethod.off_perc }}%</v-col
            >
          </v-row> -->
          <v-row class="px-4">
            <v-col cols="6" class="d-flex align-center">Plano</v-col>
            <v-col cols="6" class="d-flex align-center justify-end">
              <v-autocomplete
                v-model="planShortName"
                :items="plans"
                item-text="shortName"
                no-data-text="Nenhum plano corresponde ao digitado"
                auto-select-first
                hide-details="true"
                color="#26d07c"
                @change="changePlan"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col cols="6">Compensação</v-col>
            <v-col cols="6" align="end">
              <p
                class="text-uppercase ma-0 text-body"
                style="text-align: right !important"
              >
                {{ getCompensation || 0 }}%
              </p>
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col cols="6">Material</v-col>
            <v-col cols="6" align="end">
              <p
                v-for="(material, i) of getMaterial"
                :key="i"
                class="text-uppercase ma-0 text-body"
                style="text-align: right !important"
              >
                {{ material.material }} ({{ material.value }}%)
              </p>
              <p
                v-if="!getMaterial.length"
                class="text-uppercase ma-0 text-body"
                style="text-align: right !important"
              >
                -------
              </p>
            </v-col>
          </v-row>
          <v-row class="px-4">
            <v-col cols="6">Estado</v-col>
            <v-col
              class="text-uppercase d-flex justify-end align-center"
              cols="6"
            >
              <p
                v-for="(state, i) in getStates"
                :key="i"
                class="text-uppercase ma-0 text-body"
                style="text-align: right !important"
                :style="
                  i !== getStates.length - 1
                    ? 'margin-right: 5px !important;'
                    : ''
                "
              >
                {{ state.name }}{{ i !== getStates.length - 1 ? ',' : '' }}
              </p>
            </v-col>
          </v-row>
          <v-row class="total-wrapper px-4">
            <v-col cols="4">Total</v-col>
            <v-col cols="8" align="end">
              {{ getPrice }}
              <!-- <v-row>
                <v-col
                  v-if="
                    showDiscountPercentage &&
                    getSelectedPlan.month_plan.off_perc
                  "
                  class="pa-0"
                  align="start"
                  style="
                    text-decoration: line-through !important;
                    text-decoration-color: #ff5d01;
                  "
                  cols="12"
                  >{{ getFullPrice }}</v-col
                >
                <v-col class="pa-0" align="start" cols="12">{{
                  getPrice
                }}</v-col>
              </v-row> -->
            </v-col>
          </v-row>
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import CHECKOUT_CONST from '@/constants/Checkout';
import UtilsProvider from '@/providers/UtilsProvider';
import PLANPRICES_CONST from '@/constants/PlanPrices';

export default {
  name: 'Abstract',
  data() {
    return {
      plans: PLANPRICES_CONST.DEFAULT,
      planShortName: '',
      opened: 0,
    };
  },
  computed: {
    loading() {
      return this.$store.getters.getIsLoading;
    },
    // showDiscountPercentage() {
    //   if (
    //     this.getSelectedPlan.month_plan.off_perc &&
    //     !this.loading &&
    //     (this.$store.getters.planData.coupon_code ===
    //       CHECKOUT_CONST.GREENFRIDAYCUPONS.TWENTY_TWO ||
    //       this.$store.getters.planData.coupon_code ===
    //         CHECKOUT_CONST.GREENFRIDAYCUPONS.FIFTY ||
    //       this.$store.getters.planData.coupon_code ===
    //         CHECKOUT_CONST.GREENFRIDAYCUPONS.ONE_HUNDRED ||
    //       this.$store.getters.planData.coupon_code ===
    //         CHECKOUT_CONST.GREENFRIDAYCUPONS.TWO_HUNDRED)
    //   ) {
    //     return true;
    //   }
    //   return false;
    // },
    getCompensation() {
      return this.$store.getters.liabilityPercentage;
    },
    getMaterial() {
      return this.$store.getters.materials;
    },
    getSelectedPlan() {
      return this.$store.getters.getSelectedPlan;
    },
    getSelectedPaymentMethod() {
      if (
        this.$store.getters.getPaymentForm.paymentMethod ===
        CHECKOUT_CONST.PAYMENT.BANK_SLIP
      ) {
        return this.getSelectedPlan.year_plan.bank_slip;
      }
      return this.getSelectedPlan.month_plan.credit_card;
    },
    getFullPrice() {
      if (
        this.$store.getters.getPaymentForm.paymentMethod ===
        CHECKOUT_CONST.PAYMENT.BANK_SLIP
      ) {
        return `R$ ${
          UtilsProvider.formatReal(
            this.getSelectedPlan.year_plan.bank_slip.plan_price,
          ) || 0
        }`;
      }
      return `R$ ${
        UtilsProvider.formatReal(
          this.getSelectedPlan.month_plan.credit_card.plan_price,
        ) || 0
      }`;
    },
    getPrice() {
      if (
        this.$store.getters.getPaymentForm.paymentMethod ===
        CHECKOUT_CONST.PAYMENT.BANK_SLIP
      ) {
        return `R$ ${
          UtilsProvider.formatReal(
            this.getSelectedPlan.year_plan.bank_slip.price_after_discount,
          ) || 0
        } / Ano`;
      }
      return `R$ ${
        UtilsProvider.formatReal(
          this.getSelectedPlan.month_plan.credit_card.price_after_discount,
        ) || 0
      } / Mês`;
    },
    currentStep() {
      return this.$store.getters.getCurrentValidation;
    },
    getStates() {
      return this.$store.getters.getStates;
    },
  },
  mounted() {
    this.getSelectedPlanShortName();
  },
  methods: {
    getSelectedPlanShortName(sName = null) {
      if (sName === null) {
        const planSelected = this.plans.filter(item => {
          if (
            item.link.split('=')[1].split('&')[0] === this.$route.query.plan
          ) {
            return item;
          }
          return '';
        });
        this.planShortName = planSelected[0].shortName;
      } else {
        this.planShortName = sName;
      }
    },
    changePlan(e) {
      const chandedPlanSelected = this.plans.filter(plan => {
        if (plan.shortName === e) {
          return plan;
        }
        return '';
      });

      this.$router.push({
        name: 'checkout',
        query: {
          plan: chandedPlanSelected[0].link.split('=')[1].split('&')[0],
          passo: `0${this.currentStep}`,
        },
      });

      this.getSelectedPlanShortName(chandedPlanSelected[0].shortName);
      this.$emit('changePlan');
    },
    encurtaNome(state) {
      return state.substring(3);
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.background-green
  background-color: #01ee55
  color: #fff

.background-orange
  color: #ffffff
  background-color: #ff5d01

.background-grey
  background-color: #f5f4f7

.border-top
  border-radius: 10px 10px 0 0

.border-bottom
  border-radius: 0 0 10px 10px

.col
  padding: 8px

.totalPrice
  text-transform: uppercase

.new-color
  .background-green,
  .background-orange,
  .background-grey,
  .totalPrice
    font-family: 'metropolisregular', sans-serif !important
  .background-green
    background-color: #26d07c
.abstract-content
  .v-input
    padding-top: 0
    margin-top: 0
    max-width: 110px
::v-deep
  .v-expansion-panel
    filter: drop-shadow(0px 4px 8px rgba(7, 8, 23, 0.16))
    &:before
      display: none
    .v-expansion-panel-header
      min-height: 60px
      background-color: #26d07c
      font-family: 'metropolisbold', sans-serif
      color: #003036
      line-height: 1
      font-size: 1.125rem
      .v-expansion-panel-header__icon
        .v-icon
          font-size: 35px
          color: #003036
          margin-right: -11px
    .v-expansion-panel-content
      .v-expansion-panel-content__wrap
        padding: 0
        .container
          >.row
            align-items: center
            min-height: 56px
            .col
              color: #003036
              line-height: 1
              font-size: 1rem
              &:nth-child(1)
                font-family: 'metropolisbold', sans-serif
  .v-input__control
    .v-input__slot
      &:before
        display: none
      .v-select__slot
        input
          text-transform: uppercase
        .v-input__append-inner
          margin-right: -8px
.total-wrapper
  background: #F2F2F3
  .col
    text-transform: uppercase
    font-family: 'metropolisbold', sans-serif
</style>
<style lang="sass">
.v-autocomplete__content
  .v-list-item .v-list-item__title,
  .v-list-item .v-list-item__subtitle
    text-transform: uppercase
</style>
